
<div :id="content.typeInfo" :class="jel_getClassObject(content)">
  <!-- TODO: Compléter:
  
    Utiliser le composant hyperlien et lui passer les bons paramètres
    Prévoir l'affichage d'un message flash au retour d'une MAJ. Utiliser le id pour ça.
  -->
  <div>{{ content.texte }}</div>
  <!-- TODO: Valeur du champ provenant d'un computed faisant appel au store -->
  <div>
    <b-badge
      v-if="content.afficherBadgeInfo && content.afficherBadgeInfo == 'true'"
      variant="primaire"
      >{{ content.typeInfo }}</b-badge
    >
    <template v-else>{{ content.typeInfo }}</template>
  </div>
</div>
